import { render, staticRenderFns } from "./SearchablePackageList.vue?vue&type=template&id=b0cbaa32&scoped=true"
import script from "./SearchablePackageList.vue?vue&type=script&lang=js"
export * from "./SearchablePackageList.vue?vue&type=script&lang=js"
import style0 from "./SearchablePackageList.vue?vue&type=style&index=0&id=b0cbaa32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@7.1.4_webpack@5.108.4__lodash@4.18.1_prettier@3.9.5_vue-t_1661a82514c85892bee2ee9ef8290494/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cbaa32",
  null
  
)

export default component.exports